import React from 'react';
import Header from './../../../component/common/AdminHeader';

import AddNoting from '../../../component/noting/Add';
import Loader from './../../../component/common/Loader';
import CONSTANT from './../../../constant';

import { getNotingDetail, updateNotingList } from './../../../actions/MasterAction';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            code: props.match.params.code,
            detail: undefined,
            showLoader: false
        }
    }

    componentDidMount() {
        window.scroll(0, 0);
        document.title = CONSTANT.pageTitle.home;

        getNotingDetail(this.state.code).then((res: any) => {
            if (res.result) {
                this.setState({ detail: res.result });
            }
        });
    }

    render() {
        const { detail, showLoader } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className='card homedob'>
                        <div className="row">
                            <div className="col-md-12 my-3">
                                <h1 className="page-title">Noting detail</h1>
                            </div>
                        </div>
                        {
                            detail === undefined && <p>Loading...</p>
                        }
                        {
                            detail !== undefined && <AddNoting
                                detail={detail}
                                onSubmit={this.onSubmit}
                                onCancel={this.onCancel}
                            />
                        }
                        </div>
                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
            </div>
        )
    }

    onSubmit = (model: any) => {
        
        const { code } = this.state;
        if (code !== '1') {
            this.setState({ showLoader: true });
            updateNotingList(model).then((res: any) => {
                this.setState({ showLoader: false });
                if (res) {
                    if (res.status === CONSTANT.static.apiStatus.success) {
                        alert('record update successfully');
                        this.props.history.push(CONSTANT.component.adminNoting.url);
                    } else {
                        alert(res.error);
                    }
                }
            })
        } else {
            alert('Approved Noting cannot be updated');
        }

    }

    onCancel = () => {
        this.props.history.push(CONSTANT.component.adminNoting.url);
    }
}

export default ComponentName;